import { isNil, isEmpty, startsWith } from 'ramda';

export const required = value =>
  isNil(value) || isEmpty(value) ? 'Il campo è obbligatorio.' : undefined;

export const url = value => !startsWith('http', value) ? 'Il campo deve essere un URL valido.' : undefined;
